/** User-facing MFA strings (avoid technical formats like E.164 in UI). */

export const MFA_PHONE_FIELD_LABEL = 'Mobile number';

/** Shown under the phone field when enrolling SMS. */
export const MFA_PHONE_HELPER_PROFILE =
  'Include your country code and full number (for example +1 5551234567).';

/** Short line for cards / summaries where space is tight. */
export const MFA_PHONE_HINT_SHORT = 'Use country code and full number (e.g. +1 5551234567).';
